// src/components/Footer.jsx

import React from "react";

const Footer = () => {
  return (
    <footer className="modern-footer">

      <div className="footer-container container">
        {/* Top Section: Logo + Navigation */}
        <div className="footer-top">
          {/* Updated brand name for footer */}
          <a href="/" className="footer-logo">
            BC <span>Vanc</span>ouver
          </a>
          <ul className="footer-nav-links">
            <li>
              <a href="/trails">Trails</a>
            </li>
            <li>
              <a href="/articles">Articles</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>

        {/* Bottom Section: Social + Copyright */}
        <div className="footer-bottom">
          <ul className="footer-social-links">
            <li>
              <a href="#" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a href="#" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="#" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
            </li>
          </ul>
          {/* Updated copyright */}
          <p className="copyright">
            &copy; 2025 BCouver. Your hub for restaurants, adventures, trails, and
            all the good-to-know stuff of Vancouver and British Columbia.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;